import { Injectable } from '@angular/core';

@Injectable()
export class TotalsHelper {
  static getCategoryColor(type: number, ratio: number): string {
    const colors: [string[], string[], string[], string[]] = [
      ['rgba(12,206,107,1.0)', 'rgba(249,200,14,1.0)', 'rgba(181,29,14,1.0)'],
      ['rgba(128,255,253,1.0)', 'rgba(249,131,14,1.0)', 'rgba(192,11,78,1.0)'],
      ['rgba(168,255,153,1.0)', 'rgba(279,13,14,1.0)', 'rgba(255,22,28,1.0)'],
      ['rgb(30,140,131)', 'rgb(194,69,69)', 'rgb(143,27,35)'],
    ];
    let color = '';
    if (ratio >= 0 && ratio < 50) {
      color = colors[type][0];
    } else if (ratio >= 50 && ratio < 75) {
      color = colors[type][1];
    } else if (ratio >= 75) {
      color = colors[type][2];
    }
    return color;
  }
}
